import { Injectable } from '@angular/core';
import { DwAction, DwActionHandler, DwActionResult, DwActionType } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { BannerMotionPreferencesService } from '../services/appearance/banner-motion-preferences.service';

export const TOGGLE_BANNER_ANIMATIONS = 'fitness-toggle-banner-animations';

@DwAction({ keyName: TOGGLE_BANNER_ANIMATIONS, display: 'Toggle banner animations',
    actionType: DwActionType.menuAction, isGlobal: true, allowOnce: false,
    configData: { requireValidation: false, redirectAfter: false, actionMessage: '' } })
@Injectable()
export class ToggleBannerAnimationsAction implements DwActionHandler {
    constructor(private motion: BannerMotionPreferencesService) {}
    handleAction(): Observable<DwActionResult> {
        this.motion.toggle();
        const result = new DwActionResult();
        result.success = true;
        return of(result);
    }
}
